import React, { useState, useEffect } from 'react';
import { firestore } from '../config/firebaseConfig';
import { doc, updateDoc, getDoc, arrayUnion, arrayRemove } from 'firebase/firestore';
import { MdEditNote, MdDeleteForever, MdSave, MdCancel } from 'react-icons/md';
import './Usuarios.css';

function Usuarios() {
  const [emails, setEmails] = useState([]);
  const [email, setEmail] = useState('');
  const [editEmail, setEditEmail] = useState('');
  const [editingEmail, setEditingEmail] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const tenantId = localStorage.getItem('tenantId');

  useEffect(() => {
    if (tenantId) {
      fetchEmails();
    }
  }, [tenantId]);

  const fetchEmails = async () => {
    try {
      const tenantRef = doc(firestore, 'inquilinos', tenantId);
      const tenantDoc = await getDoc(tenantRef);
      if (tenantDoc.exists()) {
        setEmails(tenantDoc.data().emailsautorizados || []);
      } else {
        console.error('Documento não encontrado');
      }
    } catch (error) {
      console.error('Erro ao buscar emails:', error);
      setError('Não foi possível carregar os emails.');
    }
  };

  const handleAddEmail = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setError('Por favor, insira um email válido.');
      return;
    }

    try {
      const tenantRef = doc(firestore, 'inquilinos', tenantId);
      await updateDoc(tenantRef, { emailsautorizados: arrayUnion(email.trim()) });
      setSuccess('Email adicionado com sucesso!');
      setEmail('');
      fetchEmails();
      setTimeout(() => setSuccess(''), 3000);
    } catch (error) {
      console.error('Erro ao adicionar email:', error);
      setError('Houve um problema ao salvar o email. Por favor, tente novamente.');
    }
  };

  const handleEditClick = (email) => {
    setEditingEmail(email);
    setEditEmail(email);
    setSuccess('');
    setError('');
  };

  const handleSaveClick = async () => {
    try {
      const tenantRef = doc(firestore, 'inquilinos', tenantId);
      
      // Remove o e-mail antigo e adiciona o novo de uma só vez
      await updateDoc(tenantRef, {
        emailsautorizados: arrayRemove(editingEmail)
      });
      await updateDoc(tenantRef, {
        emailsautorizados: arrayUnion(editEmail.trim())
      });
      
      setEditingEmail(null);
      setSuccess('Email atualizado com sucesso!');
      fetchEmails();
      setTimeout(() => setSuccess(''), 3000);
    } catch (error) {
      console.error('Erro ao salvar o email:', error);
      setError('Houve um problema ao atualizar o email.');
    }
  };

  const handleDelete = async (emailToRemove) => {
    try {
      const tenantRef = doc(firestore, 'inquilinos', tenantId);
      await updateDoc(tenantRef, { emailsautorizados: arrayRemove(emailToRemove) });
      setSuccess('Email removido com sucesso!');
      fetchEmails();
      setTimeout(() => setSuccess(''), 3000);
    } catch (error) {
      console.error('Erro ao remover email:', error);
      setError('Houve um problema ao remover o email. Por favor, tente novamente.');
    }
  };

  return (
    <div className="manage-usuarios-container">
      <h3>Usuários</h3>
      <form onSubmit={handleAddEmail} className="add-email-form">
        <input
          type="email"
          placeholder="Novo Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit">Adicionar Email</button>
      </form>
      {error && <div className="form-feedback form-error">{error}</div>}
      {success && <div className="form-feedback form-success">{success}</div>}

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Emails Autorizados</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {emails.map((email) => (
              <tr key={email}>
                <td>
                  {editingEmail === email ? (
                    <input
                      type="text"
                      className="edit-input"
                      value={editEmail}
                      onChange={(e) => setEditEmail(e.target.value)}
                    />
                  ) : (
                    email
                  )}
                </td>
                <td className="actions">
                  {editingEmail === email ? (
                    <>
                      <MdSave size="28" className="action-icon save-icon" onClick={handleSaveClick} title="Salvar" />
                      <MdCancel size="28" className="action-icon cancel-icon" onClick={() => setEditingEmail(null)} title="Cancelar" />
                    </>
                  ) : (
                    <>
                      <MdEditNote size="28" className="action-icon edit-icon" onClick={() => handleEditClick(email)} title="Editar" />
                      <MdDeleteForever size="28" className="action-icon delete-icon" onClick={() => handleDelete(email)} title="Remover" />
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Usuarios;
